<template>
  <el-dialog append-to-body title="演奏视频选择" :visible.sync="dialogVisible" width="500px">
    <el-form ref="form" :model="listForm" inline>
      <el-form-item>
        <el-input v-model="listForm.searchText" placeholder="请输入视频名称或ID搜索" @clear="init" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="init" type="primary">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table @row-click="rowClick" :data="collection">
      <el-table-column label="视频ID">
        <template slot-scope="scope">
          <el-radio v-model="checkedId" :label="scope.row.id">{{ scope.row.id }}</el-radio>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="视频名称">
      </el-table-column>
    </el-table>
    <pagination v-if="meta" :total="meta.total" :pagination="meta.pagination" :changed="changed" />
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="confirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { listPlay } from "@/api/music";

export default {
  name: "play-table",
  data() {
    return {
      checkedId: undefined,
      dialogVisible: false,
      collection: [],
      meta: undefined,
      listForm: {
        searchText: undefined
      }
    };
  },
  methods: {
    confirm() {
      if (!this.checkedId) return this.$message.warning("请选择视频");
      let item = this.collection.find(item => item.id === this.checkedId);
      this.checkedId = undefined;
      this.dialogVisible = false;
      this.$emit("confirm", "play", {
        id: item.id,
        label: item.id + item.name
      });
    },
    changed(page) {
      this.listForm = { ...page };
      this.init();
    },
    rowClick(row) {
      this.checkedId = row.id;
    },
    show() {
      this.dialogVisible = true;
    },
    async init() {
      let { collection, meta } = await listPlay(this.listForm);
      this.collection = collection;
      this.meta = meta;
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style scoped>
</style>